import { type FC } from 'react'
import { observer } from 'mobx-react-lite'
import { Button } from 'shared/ui'
import { getAriaLabel } from 'shared/lib'
import { uiStore } from 'shared/store/uiStore'
import { useEntitiesContext } from 'entities/EntitiesExport'
import { BillingPath } from 'entities/ExportRouters'
import styles from 'widgets/Sidebar/ui/MainDropdown/styles.module.scss'

type IUpgradeSubscriptionBtnProps = {
  onClick?: () => void
  noWrapper?: boolean
  buttonText?: string
  className?: string
}

export const UpgradeSubscriptionBtn: FC<IUpgradeSubscriptionBtnProps> = observer(
  ({ onClick, noWrapper, buttonText = 'Upgrade', className }) => {
    const { subscriptionStore, organizationStore, userPermissionsStore, featureFlagsStore } =
      useEntitiesContext()
    const isUpgradeDisabled =
      !subscriptionStore.subscriptionSuggestion &&
      (!!subscriptionStore.plan?.custom || organizationStore.is_contract)
    const canManageBilling = userPermissionsStore.canManageBilling

    if (!canManageBilling) return null

    const button = isUpgradeDisabled ? (
      <Button
        id='intercom-custom-plan_sidebar-button'
        text={buttonText}
        intent='positive'
        fullWidth
        className={className}
        onClick={noWrapper ? onClick : undefined}
      />
    ) : (
      <Button
        text={buttonText}
        intent='positive'
        fullWidth
        className={className}
        onClick={() => {
          if (noWrapper) onClick?.()
          if (subscriptionStore.subscriptionSuggestion && !organizationStore.isClient) {
            uiStore.changeRouteViaVue({
              path: featureFlagsStore.billing_overview_v2
                ? `/${BillingPath.overview}`
                : `/${BillingPath.upgrade}`,
              options: {
                state: {
                  checkOpportunity: true,
                },
              },
            })
          } else {
            uiStore.changeRouteViaVue({
              path: `/${BillingPath.upgrade}`,
            })
          }
        }}
      />
    )

    if (noWrapper) return button

    return (
      <div
        className={styles.blockWrapper}
        aria-label={getAriaLabel('UpgradeSubscriptionBtn')}
        onClick={onClick}
      >
        {button}
      </div>
    )
  }
)
